import { formatCurrency, formatDuration, formatTime } from '../../../utils/datetime';

const STATUS_STYLES = {
  confirmed: 'bg-ink-900/5 text-ink-700',
  arrived: 'bg-saffron-500/15 text-saffron-800',
  completed: 'bg-emerald-50 text-emerald-800',
  cancelled: 'bg-red-50 text-red-700',
  no_show: 'bg-ink-900/5 text-ink-600',
};

export const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${
      STATUS_STYLES[status] || STATUS_STYLES.confirmed
    }`}
  >
    {(status || 'confirmed').replace('_', ' ')}
  </span>
);

export const AppointmentRow = ({
  appointment,
  currency: businessCurrency,
  onStatusChange,
  actions = [],
}) => {
  const appt = appointment;
  const currency = appt.currency || appt.service?.currency || businessCurrency;

  return (
    <li className="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
      <div className="flex min-w-0 items-start gap-3 sm:gap-4">
        <div className="flex-none bg-ink-900 px-3 py-2 text-center text-sand-50">
          <p className="text-sm font-semibold tabular-nums">{formatTime(appt.startAt)}</p>
          <p className="text-[11px] text-sand-300">{formatTime(appt.endAt)}</p>
        </div>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <p className="truncate font-medium text-ink-900">{appt.client?.name || 'Client'}</p>
            <StatusBadge status={appt.status} />
          </div>
          <p className="mt-1 text-sm text-ink-700/80">
            {appt.service?.name || 'Service'}
            {appt.service?.durationMinutes
              ? ` · ${formatDuration(appt.service.durationMinutes)}`
              : ''}
            {appt.staff?.name ? ` · ${appt.staff.name}` : ''}
          </p>
          <p className="mt-1 text-sm font-medium text-ink-900">
            {formatCurrency(appt.price || appt.service?.price || 0, currency)}
            {appt.source === 'booking_link' ? (
              <span className="ml-2 text-xs font-normal uppercase tracking-[0.12em] text-ink-600/60">
                Online
              </span>
            ) : null}
          </p>
        </div>
      </div>

      {(actions.length > 0 || onStatusChange) && (
        <div className="flex flex-wrap gap-2">
          {actions.map((action) => (
            <button
              key={action.id || action.status || action.label}
              type="button"
              disabled={action.disabled}
              onClick={() =>
                action.onClick
                  ? action.onClick(appt)
                  : onStatusChange?.(appt.id, action.status)
              }
              className={
                action.primary
                  ? 'bg-saffron-500 px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-ink-900 hover:bg-saffron-400 disabled:opacity-50'
                  : action.danger
                    ? 'px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-red-700 ring-1 ring-red-200 hover:bg-red-50 disabled:opacity-50'
                    : 'px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-ink-900 ring-1 ring-ink-900/20 hover:bg-white disabled:opacity-50'
              }
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </li>
  );
};

export default AppointmentRow;
